// extracted by mini-css-extract-plugin
export default {"feedbackButton":"XkYecS4h","feedbackContainer":"Kt0Z8PSs","feedbackContainerMobile":"Kg9M442e","modalTitle":"XsdKAmvz","componentText":"bCOicEwD"};